define([
    "./classifiableService",
    "./classifiableModule",
    "./classifiableEdition"
], function () {
});